<template>
    <div class="patient-profile">
        <form @submit.prevent="handleSubmit">
            <div class="form-group">
                <label for="motivo_consulta">Motivo de la consulta</label>
                <div class="editor-wrapper">
                    <quill-editor v-model:value="formData.motivo_consulta" :options="$editorOptions" class="editor modern" />
                    <div class="editor-footer">
                        <div class="editor-stats">
                            <span class="stat-item">
                                <i class="fas fa-font"></i>
                                {{ getTextLength(formData.motivo_consulta) }} caracteres
                            </span>
                            <span class="stat-item">
                                <i class="fas fa-align-left"></i>
                                {{ getWordCount(formData.motivo_consulta) }} palabras
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="antecedentes_personales_patologicos">Antecedentes Personales Patológicos</label>
                        <div class="editor-wrapper">
                            <quill-editor
v-model:value="formData.antecedentes_personales_patologicos"
                                :options="$editorOptions" class="editor modern" />
                            <div class="editor-footer">
                                <div class="editor-stats">
                                    <span class="stat-item">
                                        <i class="fas fa-font"></i>
                                        {{ getTextLength(formData.antecedentes_personales_patologicos) }} caracteres
                                    </span>
                                    <span class="stat-item">
                                        <i class="fas fa-align-left"></i>
                                        {{ getWordCount(formData.antecedentes_personales_patologicos) }} palabras
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="antecedentes_personales_oftalmologicos">Antecedentes Personales
                            Oftalmológicos</label>
                        <div class="editor-wrapper">
                            <quill-editor
v-model:value="formData.antecedentes_personales_oftalmologicos"
                                :options="$editorOptions" class="editor modern" />
                            <div class="editor-footer">
                                <div class="editor-stats">
                                    <span class="stat-item">
                                        <i class="fas fa-font"></i>
                                        {{ getTextLength(formData.antecedentes_personales_oftalmologicos) }} caracteres
                                    </span>
                                    <span class="stat-item">
                                        <i class="fas fa-align-left"></i>
                                        {{ getWordCount(formData.antecedentes_personales_oftalmologicos) }} palabras
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="antecedentes_heredofamiliares_oftalmologicos">Antecedentes Heredofamiliares
                            Oftalmológicos</label>
                        <div class="editor-wrapper">
                            <quill-editor
v-model:value="formData.antecedentes_heredofamiliares_oftalmologicos"
                                :options="$editorOptions" class="editor modern" />
                            <div class="editor-footer">
                                <div class="editor-stats">
                                    <span class="stat-item">
                                        <i class="fas fa-font"></i>
                                        {{ getTextLength(formData.antecedentes_heredofamiliares_oftalmologicos) }}
                                        caracteres
                                    </span>
                                    <span class="stat-item">
                                        <i class="fas fa-align-left"></i>
                                        {{ getWordCount(formData.antecedentes_heredofamiliares_oftalmologicos) }}
                                        palabras
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="antecedentes_alergicos">Antecedentes Alérgicos</label>
                        <div class="editor-wrapper">
                            <quill-editor
v-model:value="formData.antecedentes_alergicos" :options="$editorOptions"
                                class="editor modern" />
                            <div class="editor-footer">
                                <div class="editor-stats">
                                    <span class="stat-item">
                                        <i class="fas fa-font"></i>
                                        {{ getTextLength(formData.antecedentes_alergicos) }} caracteres
                                    </span>
                                    <span class="stat-item">
                                        <i class="fas fa-align-left"></i>
                                        {{ getWordCount(formData.antecedentes_alergicos) }} palabras
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="measurements my-4">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>OD</th>
                            <th></th>
                            <th>OI</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="field in measurementFields" :key="field">
                            <td>
                                <input v-model="formData[field + '_od']" type="text" class="form-control">
                            </td>
                            <td class="text-center">
                                {{ formatFieldLabel(field) }}
                            </td>
                            <td>
                                <input v-model="formData[field + '_oi']" type="text" class="form-control">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="form-group">
                <label for="notas">Notas</label>
                <div class="editor-wrapper">
                    <quill-editor v-model:value="formData.notas" :options="$editorOptions" class="editor modern" />
                    <div class="editor-footer">
                        <div class="editor-stats">
                            <span class="stat-item">
                                <i class="fas fa-font"></i>
                                {{ getTextLength(formData.notas) }} caracteres
                            </span>
                            <span class="stat-item">
                                <i class="fas fa-align-left"></i>
                                {{ getWordCount(formData.notas) }} palabras
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="measurements my-4">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>OD</th>
                            <th></th>
                            <th>OI</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="field in measurementEFFields" :key="field">
                            <td>
                                <input v-model="formData[field + '_od']" type="text" class="form-control">
                            </td>
                            <td class="text-center">
                                {{ formatFieldLabel(field) }}
                            </td>
                            <td>
                                <input v-model="formData[field + '_oi']" type="text" class="form-control">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="form-group">
                <label>Anatomía Ocular</label>
                <div class="canvas-grid">
                    <div class="canvas-card">
                        <h5 class="canvas-title">Globo Ocular OD</h5>
                        <BackgroundCanvas
key="eye1-canvas"
                            :initial-shapes="parsedShapes(formData.anatomia_globo_ocular_od)" imagepath="/img/eye1.png"
                            @save-shapes="newShapes => handleSaveShapes(newShapes, 'anatomia_globo_ocular_od')" />
                    </div>
                    <div class="canvas-card">
                        <h5 class="canvas-title">Globo Ocular OI</h5>
                        <BackgroundCanvas
key="eye2-canvas"
                            :initial-shapes="parsedShapes(formData.anatomia_globo_ocular_oi)" imagepath="/img/eye2.png"
                            @save-shapes="newShapes => handleSaveShapes(newShapes, 'anatomia_globo_ocular_oi')" />
                    </div>
                    <div class="canvas-card">
                        <h5 class="canvas-title">Retina OD</h5>
                        <BackgroundCanvas
key="eye3-canvas" :initial-shapes="parsedShapes(formData.anatomia_retina_od)"
                            imagepath="/img/eye3.png"
                            @save-shapes="newShapes => handleSaveShapes(newShapes, 'anatomia_retina_od')" />
                    </div>
                    <div class="canvas-card">
                        <h5 class="canvas-title">Retina OI</h5>
                        <BackgroundCanvas
key="eye4-canvas" :initial-shapes="parsedShapes(formData.anatomia_retina_oi)"
                            imagepath="/img/eye4.png"
                            @save-shapes="newShapes => handleSaveShapes(newShapes, 'anatomia_retina_oi')" />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="diagnostico">Diagnóstico</label>
                        <div class="editor-wrapper">
                            <quill-editor
v-model:value="formData.diagnostico" :options="$editorOptions"
                                class="editor modern" />
                            <div class="editor-footer">
                                <div class="editor-stats">
                                    <span class="stat-item">
                                        <i class="fas fa-font"></i>
                                        {{ getTextLength(formData.diagnostico) }} caracteres
                                    </span>
                                    <span class="stat-item">
                                        <i class="fas fa-align-left"></i>
                                        {{ getWordCount(formData.diagnostico) }} palabras
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="plan">Plan</label>
                        <div class="editor-wrapper">
                            <quill-editor v-model:value="formData.plan" :options="$editorOptions" class="editor modern" />
                            <div class="editor-footer">
                                <div class="editor-stats">
                                    <span class="stat-item">
                                        <i class="fas fa-font"></i>
                                        {{ getTextLength(formData.plan) }} caracteres
                                    </span>
                                    <span class="stat-item">
                                        <i class="fas fa-align-left"></i>
                                        {{ getWordCount(formData.plan) }} palabras
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import api from '@/services/api';
import BackgroundCanvas from '@/components/BackgroundCanvas.vue';
import { useCanvasShapes } from '@/composables/useCanvasShapes';
import { notify } from '@/utils/globalFunctions';

const props = defineProps({
    patientRecord: {
        type: Object,
        required: true
    }
});

// Funciones para contar caracteres y palabras
const getTextLength = (html) => {
    if (!html) return 0;
    const text = html.replace(/<[^>]*>/g, '');
    return text.length;
};

const getWordCount = (html) => {
    if (!html) return 0;
    const text = html.replace(/<[^>]*>/g, '').trim();
    if (!text) return 0;
    return text.split(/\s+/).length;
};

// Usar el composable para manejar shapes de canvas
const { parsedShapes, serializeShapesForApi } = useCanvasShapes();

// Handler personalizado para oftalmología (usa estructura anidada)
async function handleSaveShapes(newShapes, field) {
    const serialized = serializeShapesForApi(newShapes);
    formData.value[field] = serialized;

    try {
        await api.put(`/pacientes/${props.patientRecord.id}/ophthalmic-history`, {
            ophthalmic_history: {
                [field]: serialized
            }
        });

        console.log(`👁️ JSON guardado en el campo ${field}:`, serialized);
        
        // Mostrar notificación de éxito
        notify(
            'Guardado exitoso',
            'Anatomía ocular guardada correctamente',
            'success',
            'fa-regular fa-circle-check'
        );
    } catch (error) {
        console.error(`❌ Error al guardar ${field}:`, error);
        
        // Mostrar notificación de error
        notify(
            'Error al guardar',
            'No se pudo guardar el dibujo. Por favor, intenta de nuevo.',
            'danger',
            'fa-regular fa-circle-xmark'
        );
        
        throw error;
    }
}

const formData = ref({
    ophthalmic_history: {
        motivo_consulta: '',
        antecedentes_personales_patologicos: '',
        antecedentes_personales_oftalmologicos: '',
        antecedentes_heredofamiliares_oftalmologicos: '',
        antecedentes_alergicos: '',
        av_od: '',
        av_oi: '',
        estenopeico_od: '',
        estenopeico_oi: '',
        avcc_od: '',
        avcc_oi: '',
        rx_ant_od: '',
        rx_ant_oi: '',
        rx_actual_od: '',
        rx_actual_oi: '',
        bajo_dilatacion_p_od: '',
        bajo_dilatacion_p_oi: '',
        rx_ldc_actual_od: '',
        rx_ldc_actual_oi: '',
        di_od: '',
        di_oi: '',
        add_od: '',
        add_oi: '',
        diametro_pupilar_od: '',
        diametro_pupilar_oi: '',
        grosor_epitelial_od: '',
        grosor_epitelial_oi: '',
        estroma_residual_od: '',
        estroma_residual_oi: '',
        queratometria_plana_od: '',
        queratometria_plana_oi: '',
        queratometria_curva_od: '',
        queratometria_curva_oi: '',
        paquimetria_od: '',
        paquimetria_oi: '',
        ojo_dominante_od: '',
        ojo_dominante_oi: '',
        cirugia_a_programar_od: '',
        cirugia_a_programar_oi: '',
        amsler_od: '',
        amsler_oi: '',
        ishihara_od: '',
        ishihara_oi: '',
        prisma_od: '',
        prisma_oi: '',
        parpados_od: '',
        parpados_oi: '',
        orbita_od: '',
        orbita_oi: '',
        via_lagrimal_od: '',
        via_lagrimal_oi: '',
        movimientos_oculares_od: '',
        movimientos_oculares_oi: '',
        reflejos_pupilares_od: '',
        reflejos_pupilares_oi: '',
        funcion_gi_meibomio_od: '',
        funcion_gi_meibomio_oi: '',
        but_od: '',
        but_oi: '',
        pio_od: '',
        pio_oi: '',
        notas: '',
        anatomia_globo_ocular_od: '',
        anatomia_globo_ocular_oi: '',
        anatomia_retina_od: '',
        anatomia_retina_oi: '',
        diagnostico: '',
        plan: ''
    }
});

// Arreglo de los campos que se mostrarán en la tabla
const measurementFields = [
    'av',
    'estenopeico',
    'avcc',
    'rx_ant',
    'rx_actual',
    'bajo_dilatacion_p',
    'rx_ldc_actual',
    'di',
    'add',
    'diametro_pupilar',
    'grosor_epitelial',
    'estroma_residual',
    'queratometria_plana',
    'queratometria_curva',
    'paquimetria',
    'ojo_dominante',
    'cirugia_a_programar',
    'amsler',
    'ishihara',
    'prisma'
];

const measurementEFFields = [
    'parpados',
    'orbita',
    'via_lagrimal',
    'movimientos_oculares',
    'reflejos_pupilares',
    'funcion_gi_meibomio',
    'but',
    'pio'
];

// Función para formatear el nombre del campo (por ejemplo, de "av" a "AV")
const formatFieldLabel = (field) => {
    return field.replace(/_/g, ' ').toUpperCase();
};

const loadData = async () => {
    try {
        const response = await api.get(`/pacientes/${props.patientRecord.id}/`);
        Object.assign(formData.value, response.data.data.ophthalmic_history);

    } catch (error) {
        console.error('Error al cargar los datos del paciente:', error);
    }
};

const saveData = async () => {
    try {
        await api.put(`/pacientes/${props.patientRecord.id}/ophthalmic-history`, {
            ophthalmic_history: formData.value
        });
    } catch (error) {
        console.error('Error al guardar los datos del paciente:', error);
    }
};

watch(formData, saveData, { deep: true });

// Watch para detectar cambios de paciente
watch(() => props.patientRecord.id, (newId, oldId) => {
    if (newId !== oldId) {
        console.log('🔄 Cambio de paciente detectado en PatientOF:', oldId, '->', newId);
        // Resetear formData antes de cargar nuevos datos
        Object.keys(formData.value).forEach(key => {
            if (typeof formData.value[key] === 'string') {
                formData.value[key] = '';
            }
        });
        loadData();
    }
});

onMounted(() => {
    loadData();
});
</script>

<style scoped>
.patient-profile {
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
}

.form-group {
    margin-bottom: 15px;
}

.form-control {
    width: 100%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.btn {
    background-color: #007bff;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.btn:hover {
    background-color: #0056b3;
}

.canvas-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 15px;
    margin-bottom: 20px;
    position: relative;
}

.canvas-card {
    padding: 12px;
    background: #f8fafc;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
    display: flex;
    flex-direction: column;
    position: relative;
    min-height: 350px;
}

.canvas-title {
    font-size: 0.9rem;
    font-weight: 600;
    color: #334155;
    margin: 0 0 12px 0;
    text-align: center;
}

.canvas-card :deep(.background-canvas) {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.canvas-card :deep(.drawing-canvas) {
    width: 100% !important;
    height: auto !important;
    max-height: 280px;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    object-fit: contain;
}

.canvas-card :deep(.mode-bar),
.canvas-card :deep(.brush-controls) {
    width: 100%;
}

@media (max-width: 992px) {
    .canvas-grid {
        grid-template-columns: 1fr;
    }
}

.editor-wrapper {
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dee2e6;
    background: white;
    transition: all 0.2s ease;
}

.editor-wrapper:focus-within {
    border-color: #667eea;
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

:deep(.ql-toolbar) {
    background: #f8f9fa;
    border: none;
    border-bottom: 1px solid #dee2e6;
    padding: 0.75rem;
}

:deep(.ql-container) {
    border: none !important;
    font-size: 0.95rem;
    font-family: inherit;
}

:deep(.ql-editor) {
    min-height: 150px;
    padding: 1rem;
}

.editor-footer {
    background: #f8f9fa;
    border-top: 1px solid #dee2e6;
    padding: 0.5rem 1rem;
}

.editor-stats {
    display: flex;
    gap: 1rem;
}

.stat-item {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    font-size: 0.75rem;
    color: #6c757d;
}
</style>
